module.exports = __webpack_public_path__ + "img/swag_bag.95ba8825.png";